import * as Sentry from "@sentry/nuxt";

Sentry.init({
  // If set up, you can use your runtime config here
  // dsn: useRuntimeConfig().public.sentry.dsn,
  dsn: "https://353de7c439e42139416a9020cfe1e4d5@o357760.ingest.us.sentry.io/4507971412557824",
  
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  integrations: [
    // Sentry.captureConsoleIntegration()
  ],
   
  ignoreErrors: [
    "Non-Error promise rejection captured with value: Object Not Found Matching Id",
    "No ack for postMessage",
    "No handler found for post message",

    // Meta Android in-app browser native bridge noise
    /^Error invoking (?:postMessage|enableDidUserTypeOnKeyboardLogging|enableSubresourceLogging|enableButtonsClickedMetaDataLogging): Java object is gone$/,
    /^Error invoking postMessage: Java exception was raised during method invocation$/,

    // Expected validation and booking contention already shown to the customer
    /^Tokenization failed with status: Invalid and errors:/,
    /^Sorry, the appointment time is no longer available(?: \(currently being booked\))?\.$/,

    "Trying to start an Apple Pay session from a document with an insecure parent frame.",
    "Cannot destructure property 'default' of '(intermediate value)' as it is undefined.",
    "The operation is insecure.",
    "navigator.permissions is not available.",
    "Can't find variable: SCDynimacBridge",
    "Invalid call to runtime.sendMessage()",
    "undefined is not an object (evaluating 'window.webkit.messageHandlers",

    // Caused by site being embedded without widget code or nested iframes without allow="payment" such as wix sites
    "Third-party iframes are not allowed to request payments unless explicitly allowed via Feature-Policy (payment)",

    // Facebook tag issue
    "#?fbclid="
  ]
});
